import { GOOGLE_LIBRARY_LOADED } from 'bento-ordering/base/actions/actionTypes';

export const setGoogleLoaded = () => {
  return {
    type: GOOGLE_LIBRARY_LOADED
  };
};
